import { Box, Button } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useFormContext } from '../../contexts/FormContext';
import { useFormData } from '../../hooks/useFormValues';
import ChartHelpTooltip from '../common/ChartHelpTooltip.tsx';

const UploadField = ({ field }: { field: any }) => {
  const { getFormDataItem, handleChange } = useFormContext();
  const formData = useFormData();

  // Function to determine if the button should be disabled
  const isDisabled = () => {
    if (!field.hasOwnProperty('disabled')) {
      return false;
    }

    const disabledValue = field.disabled;

    // For yield_evaluation.source, we want to enable the button only if source === 'csv'
    if (disabledValue === 'yield_evaluation.source') {
      const source = getFormDataItem(formData, disabledValue);
      return source !== 'csv';
    }

    // Existing logic for other cases
    return !!getFormDataItem(formData, disabledValue);
  };

  return (
    <Box>
      <Button variant="contained" component="label" startIcon={<CloudUploadIcon />} disabled={isDisabled()}>
        {field.label}
        <input
          type="file"
          accept=".csv"
          id="csv-upload"
          style={{ display: 'none' }}
          onChange={(e: any) => {
            handleChange(
              {
                target: {
                  name: field.target,
                  value: e.target.value,
                  type: e.target.type,
                  checked: e.target.checked,
                  files: e.target.files,
                  params: field.params,
                },
              },
              field,
            );
            e.target.value = null;
          }}
        />
      </Button>
      {field.hasOwnProperty('help') ? (
        <Box sx={{ display: 'inline-flex' }}>
          <ChartHelpTooltip chartType={field.help} />
        </Box>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default UploadField;
